import { render } from "./Tambah_hm.vue?vue&type=template&id=30515b0a"
import script from "./Tambah_hm.vue?vue&type=script&lang=js"
export * from "./Tambah_hm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__